<template>
    <div class="calendar-header">
        <div class="header-left">
            <slot name="header-left"></slot>
        </div>
        <div class="header-center">
            <span v-if="!previousMonthDisabled()" class="prev-month" @click.stop="goPrev">
                <img class="month-arrow" src="../../../assets/images/icons/arrow-left.png" />
            </span>
            <span class="title">{{ title }} {{ year }}</span>
            <span v-if="!nextMonthDisabled()" class="next-month" @click.stop="goNext">
                <img class="month-arrow -right" src="../../../assets/images/icons/arrow-left.png" />
            </span>
        </div>
        <div class="header-right">
            <slot name="header-right"></slot>
        </div>
    </div>
</template>
<script type="text/babel">
import dateHelper from './utils/calendar-helpers';

export default {
    props: {
        firstDayOfMonth: {
            type: Date,
            required: true,
        },
        locale: {
            type: String,
            default: 'en',
        },
        fullMonthNames: {
            type: Boolean,
            default: true,
        },
        disabled: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    computed: {
        title() {
            return dateHelper.localMonthName(this.locale, this.firstDayOfMonth.getMonth(), this.fullMonthNames);
        },
        year() {
            return this.firstDayOfMonth.getFullYear();
        },
    },
    methods: {
        goPrev() {
            if (!this.previousMonthDisabled()) {
                let newMonth = dateHelper.shiftMonth(this.firstDayOfMonth, 1);
                this.$emit('changeMonth', newMonth);
            }
        },
        goNext() {
            if (!this.nextMonthDisabled()) {
                let newMonth = dateHelper.shiftMonth(this.firstDayOfMonth, -1);
                this.$emit('changeMonth', newMonth);
            }
        },
        previousMonthDisabled() {
            if (!this.disabled || !this.disabled.to) {
                return false;
            }
            let d = this.firstDayOfMonth;
            return this.disabled.to.getMonth() >= d.getMonth() && this.disabled.to.getFullYear() >= d.getFullYear();
        },
        nextMonthDisabled() {
            if (!this.disabled || !this.disabled.from) {
                return false;
            }
            let d = this.firstDayOfMonth;
            return this.disabled.from.getMonth() <= d.getMonth() && this.disabled.from.getFullYear() <= d.getFullYear();
        },
    },
};
</script>
<style>
.month-arrow {
    width: 14px;
    margin-bottom: 3px;
}

.month-arrow.-right {
    transform: rotate(180deg);
}

.calendar-header {
    display: flex;
    align-items: center;
    padding: 10px 0 0;
}

.header-left,
.header-right {
    flex: 1;
}

.header-center {
    flex: 3;
    text-align: center;
}

.title {
    display: inline-block;
    margin: 0 35px 15px 35px;
    min-width: 100px;
    font-weight: 700;
    font-size: 18px !important;
}

.prev-month,
.next-month {
    cursor: pointer;
}

@media (max-width: 768px) {
    .title {
        margin: 0;
    }
}
</style>



// WEBPACK FOOTER //
// calendar-header.vue?6dd185b7